import { render, staticRenderFns } from "./BaseRateLineEditor.vue?vue&type=template&id=70a042d4&scoped=true&"
import script from "./BaseRateLineEditor.vue?vue&type=script&lang=js&"
export * from "./BaseRateLineEditor.vue?vue&type=script&lang=js&"
import style0 from "./BaseRateLineEditor.vue?vue&type=style&index=0&id=70a042d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a042d4",
  null
  
)

export default component.exports